import { DeleteOutline } from "@material-ui/icons";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteProduct, getProducts } from "../../redux/apiCalls";
import excel from "../../components/excel/excel";
import Select from "react-select";
import _ from "lodash";
import { publicRequest } from "../../requestMethods";
import PageHeader from "../../components/pageHeader/PageHeader";
import Table from "../../components/advancedTable";

const statusOptions = [
    {
        label: "Inactive",
        value: "inactive",
    },
    {
        label: "Active",
        value: "active",
    },
    {
        label: "All",
        value: "all",
    },
];

const stockOptions = [
    {
        label: "Stock",
        value: true,
    },
    {
        label: "Out of Stock",
        value: false,
    },
];

export default function ProductList() {
    const dispatch = useDispatch();
    const superadmin = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.isSuperAdmin : null
    );

    const marketing = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "marketing"
            : null
    );
    const products = useSelector((state) => state.product.products);
    const [filterCategory, setFilterCategory] = useState({
        status: "all",
        model: undefined,
        brand: undefined,
        category: undefined,
        stock: true,
        limit: 20,
        page: 1,
    });
    const [isLoaded, setIsLoaded] = useState(false);
    const [brands, setBrands] = useState([]);
    const [categories, setCategories] = useState([]);
    const [name, setName] = useState(undefined);

    const getAllBrands = async () => {
        const res = await publicRequest.get("/brand/all", {
            params: { isAdmin: true },
        });
        setBrands(res.data);
    };

    useEffect(() => {
        if (brands.length === 0) {
            getAllBrands();
        }
    }, [brands]);

    const getAllCategories = async () => {
        const res = await publicRequest.get("/category/all", {
            params: { isAdmin: true },
        });
        setCategories(res.data);
    };

    useEffect(() => {
        if (categories.length === 0) {
            getAllCategories();
        }
    }, [categories]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                await getProducts(dispatch, filterCategory);
                setIsLoaded(true);
            } catch (error) {
                console.error("Error fetching products:", error);
            }
        };

        if (!isLoaded) {
            fetchData();
        }
    }, [dispatch, filterCategory, isLoaded]);

    const handleDelete = (id) => {
        deleteProduct(id, dispatch);
    };

    const handleStock = (e) => {
        setIsLoaded(false);
        setFilterCategory((prev) => {
            return { ...prev, stock: e.value, page: 1 };
        });
    };

    const handleStatus = (e) => {
        setIsLoaded(false);
        setFilterCategory((prev) => {
            return { ...prev, status: e.value, page: 1 };
        });
    };

    const handleBrand = (e) => {
        setIsLoaded(false);
        setFilterCategory((prev) => {
            return { ...prev, brand: e.value, page: 1 };
        });
    };

    const handleCategory = (e) => {
        setIsLoaded(false);
        setFilterCategory((prev) => {
            return { ...prev, category: e.value, page: 1 };
        });
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            if (name !== undefined) {
                handleNameChange(name);
            }
        }, 1000);

        return () => {
            clearTimeout(timer);
        };
    }, [name]);

    const handleDelayedNameChange = (e) => {
        setIsLoaded(false);
        setFilterCategory((prev) => {
            return { ...prev, name: e.target.value, page: 1 };
        });
    };

    const handleNameChange = (e) => {
        setName(e.target.value);
    };

    const columns = [
        {
            accessor: "brand",
            Header: "Brand",
            sortable: false,
            Cell: ({ value }) => (
                <div className="initialPadding">{value ? value.name : ""}</div>
            ),
        },
        {
            accessor: "category",
            Header: "Category",
            sortable: false,
            Cell: ({ value }) => (
                <div className="initialPadding">{value ? value.name : ""}</div>
            ),
        },
        {
            accessor: "title",
            Header: "Name",
            sortable: false,
            Cell: ({ value }) => (
                <div className="initialPadding">{value}</div>
            ),
        },
        {
            accessor: "price",
            Header: "Price",
            sortable: false,
            Cell: ({ value }) => (
                <div className="initialPadding">RM {value}</div>
            ),
        },
        {
            accessor: "action",
            Header: "Action",
            sortable: false,
            Cell: (params) => {
                return (
                    <div className="flex justify-center items-center gap-3">
                        {(superadmin || marketing) && (
                            <Link
                                style={{
                                    textDecoration: "none",
                                    color: "black",
                                }}
                                to={"/product/" + params.row.original._id}
                            >
                                <button className="red productListEdit">
                                    Edit
                                </button>
                            </Link>
                        )}
                        {superadmin && (
                            <DeleteOutline
                                className="productListDelete"
                                onClick={() => handleDelete(params.row.original._id)}
                            />
                        )}
                    </div>
                );
            },
        },
    ];

    return (
        <div className="productList">
            <PageHeader 
                title="Product List" 
                description="View and manage all products in the inventory" 
            />
            <div className="samerow">
                <div className="sameRowItem marginRight">
                    <input
                        className="inputFilter"
                        name="name"
                        value={name}
                        type="string"
                        placeholder="Name"
                        onChange={handleDelayedNameChange}
                    />
                </div>
                <div className="sameRowItem marginRight">
                    <Select
                        options={categories.map((status, i) => {
                            return {
                                label: status.name,
                                value: status._id,
                            };
                        })}
                        onChange={handleCategory}
                        placeholder="Search Category"
                    />
                </div>
                <div className="sameRowItem marginRight">
                    <Select
                        options={brands.map((status, i) => {
                            return {
                                label: status.name,
                                value: status._id,
                            };
                        })}
                        onChange={handleBrand}
                        placeholder="Search Brand"
                    />
                </div>
                <div className="sameRowItem marginRight">
                    <Select
                        options={statusOptions.map((status, i) => {
                            return {
                                label: status.label,
                                value: status.value,
                            };
                        })}
                        onChange={handleStatus}
                        value={{
                            label: _.capitalize(filterCategory.status),
                            value: filterCategory.status,
                        }}
                        placeholder="Search Status"
                    />
                </div>

                <div className="sameRowItem marginRight">
                    <Select
                        options={stockOptions.map((status, i) => {
                            return {
                                label: status.label,
                                value: status.value,
                            };
                        })}
                        onChange={handleStock}
                        value={{
                            label: _.capitalize(filterCategory.stock),
                            value: filterCategory.stock,
                        }}
                        placeholder="Search Stock"
                    />
                </div>
            </div>

            <div className="block mt-4">
                {superadmin && (
                    <button
                        onClick={() => {
                            let payload = [];
                            products.forEach((product) => {
                                let formattedExcelColor = "";
                                let formattedExcelCategory = "";
                                product.color.map(
                                    (color) =>
                                        (formattedExcelColor =
                                            formattedExcelColor +
                                            "," +
                                            color.name)
                                );
                                product.categories.map(
                                    (category) =>
                                        (formattedExcelCategory =
                                            formattedExcelCategory +
                                            "," +
                                            category)
                                );
                                payload.push({
                                    ...product,
                                    formattedExcelColor:
                                        formattedExcelColor.slice(1),
                                    formattedExcelCategory:
                                        formattedExcelCategory.slice(1),
                                    price:
                                        process.env.REACT_APP_COUNTRY ===
                                        "SINGAPORE"
                                            ? product.price
                                            : product.myprice,
                                });
                            });
                            excel({
                                excelData: payload,
                                fileName: "HaofaProduct",
                            });
                        }}
                        className="red buttonTop productListButton"
                    >
                        Export
                    </button>
                )}
            </div>

            <Table
                data={products ? products : []}
                columns={columns}
                pageCount={Math.floor((products ? products.length : 0) / 20) + 1}
                totalCount={products ? products.length : 0}
                updatePagination={setFilterCategory}
                paginationState={filterCategory}
                updateLoaded={setIsLoaded}
            />
        </div>
    );
}
